module.exports = __webpack_public_path__ + "img/icon-daohang.61231a68.svg";